export const ROUTES = {
     TASK_DETAILS : (orgName : string, taskFriendlyId : number) => `/task/${orgName}-${taskFriendlyId}`
}